import React from 'react'
import { Contact as PureContact } from '../contact'
import { Skeleton } from '../skeleton'
import { useLocalBusinessCard } from '../../store'
import { useNavigateToCard } from '../../hooks'

export const Contact: React.VFC = () => {
  const businessCard = useLocalBusinessCard()
  const navigateToCard = useNavigateToCard()
  return (
    <Skeleton
      value={businessCard}
      render={({ avatar, userName, companyPosition, chatUrl }) => (
        <PureContact
          avatar={avatar}
          name={userName}
          title={companyPosition}
          chat={chatUrl}
          onCard={navigateToCard}
        />
      )}
    />
  )
}
